import { useCallback, useEffect, useState } from 'react'
import { Button, Form, Input, InputNumber, Modal, Switch, Table, message } from 'antd'
import { adminApi, type PageResult } from '../../api'
import { PageHeader, tablePagination, useServerPagination } from '../../components/ui'

type Menu = {
  id: number
  parent_id: number | null
  code: string
  name: string
  path: string
  sort_order: number
  is_visible: boolean
}

export default function Menus() {
  const { page, pageSize, handlePaginationChange, paginationOptions } = useServerPagination()
  const [rows, setRows] = useState<Menu[]>([])
  const [total, setTotal] = useState(0)
  const [open, setOpen] = useState(false)
  const [ed, setEd] = useState<Menu | null>(null)
  const [form] = Form.useForm()

  const load = useCallback((p: number, ps: number) => {
    adminApi
      .get<PageResult<Menu>>('/admin/menus', { params: { page: p, page_size: ps } })
      .then((r) => {
        setRows(r.data.items)
        setTotal(r.data.total)
      })
      .catch((e) => message.error(e.message))
  }, [])

  useEffect(() => {
    load(page, pageSize)
  }, [page, pageSize, load])

  const submit = () => {
    void form.validateFields().then((v) => {
      const req = ed ? adminApi.put(`/admin/menus/${ed.id}`, v) : adminApi.post('/admin/menus', v)
      req
        .then(() => {
          message.success('已保存')
          setOpen(false)
          load(page, pageSize)
        })
        .catch((e) => message.error(e.message))
    })
  }

  return (
    <div>
      <PageHeader title="菜单管理" />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <Button
          type="primary"
          onClick={() => {
            setEd(null)
            form.resetFields()
            form.setFieldsValue({ is_visible: true, sort_order: 0 })
            setOpen(true)
          }}
        >
          新增菜单
        </Button>
      </div>
      <Table
        rowKey="id"
        size="small"
        dataSource={rows}
        pagination={tablePagination(page, total, handlePaginationChange, paginationOptions)}
        columns={[
          { title: '编码', dataIndex: 'code' },
          { title: '名称', dataIndex: 'name' },
          { title: '路径', dataIndex: 'path' },
          { title: '排序', dataIndex: 'sort_order', width: 70 },
          {
            title: '操作',
            render: (_, r) => (
              <Button
                size="small"
                onClick={() => {
                  setEd(r)
                  form.setFieldsValue(r)
                  setOpen(true)
                }}
              >
                编辑
              </Button>
            ),
          },
        ]}
      />
      <Modal title={ed ? '编辑菜单' : '新增菜单'} open={open} onOk={submit} onCancel={() => setOpen(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="code" label="编码" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="name" label="名称" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="path" label="路由路径">
            <Input placeholder="/manage/xxx" />
          </Form.Item>
          <Form.Item name="parent_id" label="父级 ID">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="sort_order" label="排序">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="is_visible" label="可见" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
